import React from "react";
import { MapPin, Check } from "lucide-react";
import { Reveal } from "./Motion";
import { REGIONS, ASSETS } from "../data/site";

export const Regions = () => (
  <section
    id="regioes"
    data-testid="regions-section"
    className="relative bg-[#050505] py-20 md:py-28 overflow-hidden"
  >
    <div
      className="absolute inset-0 opacity-[0.12]"
      style={{
        backgroundImage: `url(${ASSETS.wetStreet})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    />
    <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-[#050505]/85 to-[#050505]" />

    <div className="max-w-[1400px] mx-auto px-4 md:px-10 relative z-10 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      {/* Text + list */}
      <Reveal>
        <span className="font-mono-tech text-xs tracking-[0.25em] text-[#e60000] uppercase">
          / Onde atendemos
        </span>
        <h2 className="mt-4 font-display font-bold uppercase text-white text-4xl md:text-5xl tracking-tight leading-[0.95]">
          Guincho em Porto Alegre e Região
        </h2>
        <p className="mt-5 text-neutral-400 leading-relaxed max-w-xl">
          A FS Guinchos realiza atendimento em Porto Alegre e diversas cidades da
          Região Metropolitana, oferecendo serviços de guincho, reboque, remoção e
          transporte de veículos.
        </p>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
          {REGIONS.map((r) => (
            <div
              key={r}
              data-testid={`region-${r}`}
              className="flex items-center gap-3 text-neutral-200"
            >
              <span className="w-5 h-5 flex items-center justify-center bg-[#e60000]/15 text-[#e60000] shrink-0">
                <Check size={13} />
              </span>
              <span className="text-sm">{r}</span>
            </div>
          ))}
        </div>
      </Reveal>

      {/* Google Maps embed */}
      <Reveal delay={0.15}>
        <div
          data-testid="regions-map"
          className="relative w-full h-[380px] md:h-[520px] bg-[#0a0a0a] border border-white/10 overflow-hidden clip-frame"
        >
          <div className="absolute top-4 left-4 z-10 pointer-events-none bg-[#050505]/80 backdrop-blur-sm px-3 py-2 border border-white/10">
            <span className="font-mono-tech text-[10px] tracking-widest text-[#e60000] uppercase flex items-center gap-1.5">
              <MapPin size={12} /> Porto Alegre / RS — Área de Atendimento
            </span>
          </div>
          <iframe
            title="Mapa de atendimento FS Guinchos - Porto Alegre e Região Metropolitana"
            src="https://maps.google.com/maps?q=Porto%20Alegre%2C%20RS&t=&z=10&ie=UTF8&iwloc=&output=embed"
            className="w-full h-full border-0"
            style={{ filter: "invert(90%) hue-rotate(180deg) contrast(0.9) brightness(0.95)" }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </div>
      </Reveal>
    </div>
  </section>
);
